<script>
    import nl from "flag-icon-css/flags/4x3/nl.svg";
    import gb from "flag-icon-css/flags/4x3/gb.svg";
    export let flag;

    let flagHtml = '';
    if(flag === 'nl_NL') {
        flagHtml = nl;
    }
    if(flag === 'en_GB') {
        flagHtml = gb;
    }
</script>

{@html flagHtml}